import {
    IsInt,
    IsEmail,
    IsString,
    IsDateString,
    IsNumber,
    IsDate,
    IsAlphanumeric,
    MaxLength,
    Matches,
    IsOptional,
    IsNotEmpty,
    ValidateNested,
} from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { ZoneDto } from '@gtpl/shared-models/masters';
export class RackDTO {
    @ApiProperty()
    @IsOptional()
    rackId?: number;


    @ApiProperty()
    @IsOptional()
    zoneId: number;


    @ApiProperty()
    @IsNotEmpty({ message: "Name should not be empty" })
    rackName: string;

    @ApiProperty()
    isActive: boolean;
    createdAt: Date;


    @ApiProperty()
    @IsNotEmpty({ message: 'Code should not be empty' })
    rackCode: string;
    @ApiProperty()
    @IsNotEmpty({ message: 'reservedForDummy should not be empty' })
    reservedForDummy: number;


    @ApiProperty()
    @IsOptional()
    @MaxLength(40, { message: 'Created User allows maximum 40 characters' })
    @Matches(new RegExp('^(?:[a-zA-Z\\s]|)+$'), {
        message: 'created user should be only numbers',
    })
    createdUser: string;

    updatedAt: Date;
    @ApiProperty()
    @IsOptional()
    @MaxLength(40, { message: 'Updated User allows maximum 40 characters' })
    @Matches(new RegExp('^(?:[a-zA-Z\\s]|)+$'), {
        message: 'updated user should be only numbers',
    })
    updatedUser: string;

    @ApiProperty()
    versionFlag: number;
    racksinfo: ZoneDto;

    @ApiProperty()
    @IsOptional()
    zoneName: string;

    @ApiProperty()
    plantId:number;

    @ApiProperty()
    allocatedPlantId:number;
    @ApiProperty()
    allocatedZoneId:number;
}
